import {formatDate, formatDateRange, formatDurationAsDays} from '../util/textFormat';

export default function calculateSchedule(input: {firstAppeared?: Date; lastAppeared?: Date}) {
    const format = formatDate('MMM d yyyy');
    const {firstAppeared, lastAppeared} = input;
    if (!firstAppeared && lastAppeared) {
        return `Unknown Date - ${format(lastAppeared)}`;
    }
    if (!lastAppeared && firstAppeared) {
        return `${format(firstAppeared)} - Unknown Date`;
    }
    if (firstAppeared && lastAppeared) {
        const formattedRange = formatDateRange(firstAppeared, lastAppeared, false);
        const days = formatDurationAsDays(
            firstAppeared,
            new Date(Math.min(+new Date(), +lastAppeared))
        );
        return `${formattedRange} (${days.replace(' ', '\xa0')})`;
    }
    return 'Unknown Schedule';
}
